import React from 'react'
import classNames from 'classnames/bind'
import type { UserProfile } from '../../types'
import styles from '../../UserProfile.module.scss'

const cx = classNames.bind(styles)

interface TimelineTabProps {
  user: UserProfile
  joinedDate: string
  isVerified: boolean
}

export default function TimelineTab({ user, joinedDate, isVerified }: TimelineTabProps) {
  return (
    <div className={cx('timeline')}>
      <div className={cx('timelineItem')}>
        <div className={cx('timelineDot')} />
        <div className={cx('timelineContent')}>
          <div className={cx('timelineTitle')}>Account registered</div>
          <div className={cx('timelineDate')}>{joinedDate}</div>
        </div>
      </div>
      {isVerified && (
        <div className={cx('timelineItem')}>
          <div className={cx('timelineDot')} />
          <div className={cx('timelineContent')}>
            <div className={cx('timelineTitle')}>Email verified</div>
            <div className={cx('timelineDate')}>
              {new Date(user.email_verified_at!).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

